import { CalendarTranslateService } from './../../../modules/UIKit/services/calendarTranslate.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SelectItem, ConfirmationService, MessageService } from 'primeng/components/common/api';
import { DragDropModule } from 'primeng/primeng';
import { Campaign2Service } from 'app/services/campaign-2.0/campaign2.service';
import { FormGroup, FormBuilder, FormControl, Validators, FormArray } from '@angular/forms';
import { Component, OnInit, ViewChild } from '@angular/core';
import * as moment from 'moment';
import { CampaignDragAndDropComponent } from '../campaign-drag-and-drop/campaign-drag-and-drop.component';


@Component({
  selector: 'app-coupon-emission-setup',
  templateUrl: './coupon-emission-setup.component.html',
  styleUrls: ['./coupon-emission-setup.component.css', '../coupon-setup.scss']
})
export class CouponEmissionSetupComponent implements OnInit {
  campaignId: string;
  actionId: string;
  emissionDatesForm: FormGroup;
  touchpoints: any[] = [];
  touchpointOnline: any[] = [];
  savedPriorities: any[] = [];
  selectedTouchpoints: string[];
  selectedTouchpointsOnline: string[] = [];
  showDialog = false;
  showAddRecipientList = false;
  dialogTitle: string;
  addedStores: any[] = [];
  addedStoresId: string[] = [];
  prioritiesForm: FormGroup
  customerLists: SelectItem[] = [];
  selectedCustomerList: number;
  itemCode: any;
  barCode: string;
  messageInstanceId: number;
  actionTypeId: number;
  actionTypeCode: string;
  barcodeTypePid: number;
  invalidSubmit = false;
  stateAction: string;
  actualStep: string = "emission";
  showEmissionDatesForm: boolean;
  messages: SelectItem[] = [];
  MessageInstanceDtoSchema: any;
  name: string = "";
  startCampaignDate;
  endCampaignDate;
  startingEndDate;
  tpWithoutStores: number[];
  priorityOfflineTouchpoint = -99;
  prioritiesSetted: boolean = true;
  listPriorityValue: any[] = [];
  campaignActionOchannelDtoList = [];
  priorityDuplicate: boolean = false;
  priorityFormValid: boolean = true;
  prioritiesOnline: any[] = [];
  touchpointsOffline: any[] = [];
  productItemList: any[] = [];
  productItemId: any;
  productItemBarcodeList: any;
  isProductItemPresent = false;
  checkBarcode: {
    start_emission_date?: any,
    end_emission_date?: any,
    start_fruition_date?: any,
    end_fruition_date?: any,
    flg_stop?: any,
    flg_warning?: any
  };
  flagDeploy: any;
  flagRolling: any;
  today = new Date();
  selectedProductItem?: any;

  constructor(
    private fb: FormBuilder,
    private campaignService: Campaign2Service,
    private translateService: TranslateService,
    private activatedRoute: ActivatedRoute,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private router: Router,
    public calendarTranslateService: CalendarTranslateService
  ) {
    this.campaignService.getDtoSchemas('MessageInstance').subscribe(res => {
      this.MessageInstanceDtoSchema = res
    });
  }

  get priorities(): FormArray {
    return this.prioritiesForm.get('priorities') as FormArray;
  }

  ngOnInit() {
    this.checkBarcode = {};
    this.campaignId = this.activatedRoute.snapshot.params['campaignId'];
    this.actionTypeId = +this.activatedRoute.snapshot.paramMap.get('actionTypeId') || null;
    this.actionTypeCode = this.activatedRoute.snapshot.paramMap.get('actionTypeCode') || null;
    this.campaignService.getParamBarcodeTypePid().subscribe((res) => { this.barcodeTypePid = res.param_code; console.log(res.param_code) });
    this.campaignService.getCampaignMessage(this.actionTypeCode === 'MSG'?"message":"coupon").subscribe(res => {
      res.forEach(message => this.messages.push({ label: message.description, value: message.id }));
    });
    if (this.activatedRoute.snapshot.params['actionId']) {
      this.showEmissionDatesForm = false;
      this.actionId = this.activatedRoute.snapshot.params['actionId'];
      this.campaignService.getCouponEmissionData(this.campaignId, this.actionId).subscribe(res => this.setData(res[0]));
    } else {
      this.showEmissionDatesForm = true;
      this.setData();
    }
    this.campaignService.getCampaign(+this.campaignId).subscribe(res => {
      this.startCampaignDate = new Date(res[0].start_date);
      this.endCampaignDate = new Date(res[0].end_date);
    });
  }

  setData(data?: any) {
    if (data) {
      this.emissionDatesForm = this.fb.group({
        startDate: [new Date(data.start_date), Validators.required],
        endDate: [new Date(data.end_date), Validators.required]
      });
      this.messageInstanceId = data.message_instance_id;
      this.actionTypeId = data.action_type_id;
      this.stateAction = data.campaign_action_status_id;
      this.name = data.name;
      this.checkBarcode.start_emission_date = data.start_date;
      this.checkBarcode.end_emission_date = data.end_date;
    } else {
      this.emissionDatesForm = this.fb.group({
        startDate: ['', Validators.required],
        endDate: ['', Validators.required]
      });
    }
    if (this.actionId) {
      this.setCustomerData();
    }
  }

  setPriorities(event) {
    this.touchpoints = event.touchpoints;
    this.selectedTouchpoints = event.selectedTouchpoints;
  }

  setCustomerData(newRecipientListId?: number) {
    this.customerLists = [{ label: '', value: null }];
    this.campaignService.getCustomerLists().subscribe(customerLists => {
      var newDistrListId : number;
      customerLists.forEach(list => {
        this.customerLists.push({ label: list.name, value: list.id })
        if(list.id === newRecipientListId)
          newDistrListId = newRecipientListId;
        });
      //if (newRecipientListId) {
        this.selectedCustomerList = newDistrListId;
      //}
      if (this.messageInstanceId) {
        this.campaignService.getMessageInstance(this.messageInstanceId).subscribe(res => {
          if (res && res.length > 0) {
            this.selectedCustomerList = newDistrListId ? newDistrListId : res[0].distribution_list_id;
            this.itemCode = res[0].codice_articolo;
            this.barCode = res[0].barcode;
            this.barcodeTypePid = res[0].barcode_type_pid;
            this.checkBarcode.start_fruition_date = res[0].start_fruition_date;
            this.checkBarcode.end_fruition_date = res[0].end_fruition_date;
            this.flagDeploy = res[0].flg_dpl;
            this.flagRolling = res[0].flg_rolling;
          }

          this.campaignService.getProductItemByHostCode(this.itemCode).subscribe(res => {
            this.productItemList = [];
            if (res) {
              res.forEach(productItem => {
                this.productItemList.push({ label: productItem.host_code + '-' + productItem.short_description, value: productItem.id, host_code: productItem.host_code })
                this.productItemId = productItem.id;
                this.selectedProductItem = this.productItemList[0];
              });
            }

            if (this.productItemId) {
              this.isProductItemPresent = true;
              this.campaignService.getProductItemBarcodeById(this.productItemId).subscribe(res => {
                this.productItemBarcodeList = [];
                if (res) {
                  res.forEach(barcode => {
                    this.productItemBarcodeList.push({ label: barcode.barcode, value: barcode.barcode  })
                  });
                }
              });
            }

          });
        });
      }
    });
  }

  saveEmissionDates() {
    if (!this.emissionDatesForm.valid) {
      this.invalidSubmit = true;
      return;
    }
    this.invalidSubmit = false;
    const data = {
      campaign_id: +this.campaignId,
      action_type_id: this.actionTypeId,
      start_date: moment(this.emissionDatesForm.get('startDate').value).format('YYYY-MM-DD'),
      end_date: moment(this.emissionDatesForm.get('endDate').value).format('YYYY-MM-DD')
    };
    if (this.actionId && this.messageInstanceId) {
      Object.assign(data, { message_instance_id: this.messageInstanceId });
      this.campaignService.updateEmissionDates(data).subscribe(() => {
        this.messageService.add({ severity: 'success', summary: this.translateService.instant('common.success'), detail: this.translateService.instant('common.operation_success') });
      });
    } else {
      this.campaignService.saveEmissionDates(data).subscribe(res => {
        this.actionId = res.id;
        this.setCustomerData();
        this.showEmissionDatesForm = false;
        this.messageService.add({ severity: 'success', summary: this.translateService.instant('common.success'), detail: this.translateService.instant('common.operation_success') });
      });
    }
  }

  onTouchpointSelection(event: any) {
    this.selectedTouchpoints = event.selectedTouchpoints;
      this.touchpointsOffline.push(event.selectedTp);
  }

  openAddRecipientList() {
    this.showAddRecipientList = this.showDialog = true;
    this.dialogTitle = this.translateService.instant('campaign.createRecipientList');
  }

  closeDialog() {
    this.showAddRecipientList =
      this.showDialog = false;
  }

  getChannels() {
    let channels: SelectItem[] = [{ label: this.translateService.instant('campaign.selectChannel'), value: null }];
    if (this.selectedTouchpoints && this.selectedTouchpoints.length > 0) {
      channels = channels.concat(this.touchpoints.filter(tp => tp.flg_offline === '0' && this.selectedTouchpoints.indexOf(tp.value.toString()) !== -1));
    }
    return channels;
  }

  setDefaultDateStart(formatted = false) {
    const startDate = this.emissionDatesForm.get('startDate').value;
    if (startDate) {
      if (formatted) {
        return moment(startDate).format(this.calendarTranslateService.pcalendarTranslate.dateFormatFilter.toUpperCase());
      } else {
        return startDate;
      }
    } else {
      return null;
    }
  }

  setDefaultDateEnd(formatted = false) {
    const endDate = this.emissionDatesForm.get('endDate').value;
    if (endDate) {
      if (formatted) {
        return moment(endDate).format(this.calendarTranslateService.pcalendarTranslate.dateFormatFilter.toUpperCase());
      } else {
        return endDate;
      }
    } else {
      return null;
    }
  }

  save() {
    this.tpWithoutStores = [];
    const channelStores = [];
    this.touchpoints.forEach(tp => {
      if (tp.storesId.length > 0) {
        tp.storesId.forEach(tpsId => {
          channelStores.push({
            ochannel_id: +tp.value,
            store_id: +tpsId
          });
        });
      }
      // Se selezionato un touchpoint con flg_offline 1 senza negozi associati
      if (this.selectedTouchpoints && this.selectedTouchpoints.indexOf(tp.value.toString()) !== -1 && tp.flg_offline === '1' && tp.storesId.length === 0) {
        this.tpWithoutStores.push(tp.value);
      }
    });

    if (this.campaignActionOchannelDtoList.length > 0) {
      this.campaignActionOchannelDtoList = [];
    }

    if (
      !this.emissionDatesForm.valid ||
      this.tpWithoutStores.length > 0 ||
      (this.prioritiesOnline.length === 0 && this.touchpointsOffline.length === 0 && (!this.selectedTouchpoints || this.selectedTouchpoints.length === 0)) ||
      !this.selectedCustomerList ||
      !this.name

    ) {
      this.invalidSubmit = true;
      return;
    }
    this.invalidSubmit = false;

    if (this.campaignActionOchannelDtoList.length === 0) {
      this.createCampaignActionOchannelList();
    }

    const data = {
      id: this.actionId,
      name: this.name,
      campaign_id: +this.campaignId,
      action_type_id: this.actionTypeId,
      barcode_type_pid: this.barcodeTypePid,
      start_date: moment(this.emissionDatesForm.get('startDate').value).format('YYYY-MM-DD'),
      end_date: moment(this.emissionDatesForm.get('endDate').value).format('YYYY-MM-DD'),
      barcode: this.barCode,
      codice_articolo: this.itemCode,
      distribution_list_id: this.selectedCustomerList,
      campaignActionOchannelDtoList: this.campaignActionOchannelDtoList,
      storeMessageOchannelDtoList: channelStores,
      flg_rolling: this.flagRolling
    }
    if (!this.priorityDuplicate) {
      if (this.messageInstanceId) {
        this.campaignService.updateCouponEmissionData(this.messageInstanceId, data).subscribe(() => {
          this.messageService.add({ severity: 'success', summary: this.translateService.instant('common.success'), detail: this.translateService.instant('common.operation_success') });
          this.goToNextStep();
        });
      } else {
        this.campaignService.saveCouponEmissionData(data).subscribe(res => {
          this.messageInstanceId = res.message_instance_id;
          this.messageService.add({ severity: 'success', summary: this.translateService.instant('common.success'), detail: this.translateService.instant('common.operation_success') });
          this.goToNextStep();
        });
      }
    }

  }

  goToNextStep() {
    //if (this.actionTypeCode !== 'MSG') {
      this.router.navigate(['campaign-coupon-parameters-setup/' + this.messageInstanceId, {
        actionTypeCode: this.actionTypeCode
      }]);
   /* } else {*ngIf="actionTypeCode !== 'MSG'"
      this.router.navigate([`campaign-coupon-layout-setup/${this.messageInstanceId}/${this.actionId}`, {
        actionTypeCode: this.actionTypeCode
      }]);
    }*/
  }

  /**
   * Verifica se un array di oggetti contiente duplicati per una determinata chiave
   */
  hasDuplicates(array: any, key: string) {
    const valueArr = array.map(item => item[key]);
    const isDuplicate = valueArr.some((item, index) => valueArr.indexOf(item) !== index);
    return isDuplicate;
  }

  setStartDate() {
    if (!!this.emissionDatesForm.get('startDate').value) {
      this.startingEndDate = this.emissionDatesForm.get('startDate').value;
      this.checkBarcode.start_emission_date = this.emissionDatesForm.get('startDate').value;
      return this.emissionDatesForm.get('startDate').value;
    }
  }

  setEndDate(endDateField: any) {
    if (!!this.emissionDatesForm.get('endDate').value) {
      return this.emissionDatesForm.get('endDate').value;
    }
    else {
      if (endDateField && this.startingEndDate) {
        this.emissionDatesForm.get('endDate').setValue(this.startingEndDate);
        endDateField.calendar.currentYear = this.startingEndDate.getFullYear();
        endDateField.calendar.currentMonth = this.startingEndDate.getMonth();
      }
      this.checkBarcode.end_emission_date = this.startingEndDate;
      return this.startingEndDate
    };
  }

  createCampaignActionOchannelList() {
    const selectedPriorities = [];
    const prioritiesControls = this.prioritiesOnline;
    let priorityCounter = 1;
    if (prioritiesControls && prioritiesControls.length > 0) {
      prioritiesControls && prioritiesControls.forEach((control, i) => {
        if (control.value != null) {
          this.campaignActionOchannelDtoList.push({
            ochannel_id: control.value,
            ochannel_scope: "emission",
            priority: i++
          });
          selectedPriorities.push(control.value);
          priorityCounter++;
        }
      });
    }
    const remainingTouchPoints = []
    this.selectedTouchpoints.filter(stp => {
      let exists = false;
      this.savedPriorities.forEach(sp => {
        if(sp.value == stp) {
          exists = true;
        }
      })
      if(selectedPriorities.indexOf(+stp) === -1 && !exists) {
        remainingTouchPoints.push(stp)
      }
    });
    if (remainingTouchPoints && remainingTouchPoints.length > 0) {
      remainingTouchPoints.forEach(rtp => {
          const touchpoint = this.touchpoints.find(tp => tp.value === +rtp);
          if (touchpoint.flg_offline === '0' ) {
            this.campaignActionOchannelDtoList.push({
              ochannel_id: +rtp,
              ochannel_scope: "emission",
              priority: priorityCounter
            });
          } else {
            this.campaignActionOchannelDtoList.push({
              ochannel_id: +rtp,
              ochannel_scope: "emission",
              priority: this.priorityOfflineTouchpoint
            });
          }

      });
    }

    if (this.hasDuplicates(this.campaignActionOchannelDtoList, 'ochannel_id')) {
      this.priorityDuplicate = true;
      this.confirmationService.confirm({
        message: this.translateService.instant('campaign.duplicateChannelsError'),
        header: this.translateService.instant('common.warning'),
        rejectVisible: false,
        acceptLabel: 'OK'
      });
      return;
    } else {
      this.priorityDuplicate = false;
    }
  }

  priorityChangedHandler(priorityList: any[]) {
    this.prioritiesOnline = priorityList; // importo lista priorità dal child drag-and-drop-list;
  }

  setTouchpointOnline(event) {
    this.touchpointOnline = event;
  }

  setPrioritiesOnline(event) {
    this.savedPriorities = event;
  }

  filterByProductItem(event) {
    console.log(event)
    this.productItemBarcodeList = null;
    this.campaignService.getProductItemByHostCode(event.query).subscribe(res => {
      this.productItemList = [];
      if (res) {
        res.forEach(productItem => {
          this.productItemList.push({ label: productItem.host_code + ' - ' + productItem.short_description, value: productItem.id, host_code: productItem.host_code })
        });
      }
    });
  }

  clearProductItem() {
    this.isProductItemPresent = false;
    this.productItemList = [];
    this.productItemBarcodeList = [];
    this.productItemId = null;
    this.barCode = null;
    this.itemCode = null;
  }

  getProductItemBarcode(event) {
    console.log(event)
    this.isProductItemPresent = true;
    this.itemCode = event.host_code

    this.campaignService.getProductItemBarcodeById(event.value).subscribe(res => {
      this.productItemBarcodeList = [];
      if (res) {
        res.forEach(barcode => {
          this.productItemBarcodeList.push({ label: barcode.barcode, value: barcode.barcode })
        });
        this.barCode = res[0].barcode;
      }

    });
  }

  checkBarcodeAvailability() {
    if(!this.barCode || !this.itemCode){
      this.invalidSubmit = true;
      return;
    }

    this.checkBarcode.start_emission_date = moment(this.checkBarcode.start_emission_date).format('YYYY-MM-DD');
    this.checkBarcode.end_emission_date = moment(this.checkBarcode.end_emission_date).format('YYYY-MM-DD');

    this.campaignService.checkBarcodeAvailability(this.campaignId, this.barCode, this.messageInstanceId, this.checkBarcode).subscribe(res =>{
      if(res) {
        this.checkBarcode.flg_stop = res.flg_stop
        this.checkBarcode.flg_warning = res.flg_warning

        if (this.checkBarcode.flg_stop === true) {
          this.confirmationService.confirm({
            header: this.translateService.instant('common.warning'),
            message: this.translateService.instant('campaign.checkBarcodeStop'),
            acceptLabel: 'Ok',
            rejectVisible: false
          })
        } else if (this.checkBarcode.flg_warning === true) {
          this.confirmationService.confirm({
            header: this.translateService.instant('common.warning'),
            message: this.translateService.instant('campaign.checkBarcodeWarning'),
            acceptLabel: 'Ok',
            accept: () => this.save(),
            rejectVisible: false
          })
        } else this.save();

      }

    });

  }


}



// WEBPACK FOOTER //
// ./src/app/views/campaign-2.0/coupon-emission-setup/coupon-emission-setup.component.ts